import { TooltipDesktop } from '@cian/ui-kit/tooltip';
import { InlineText2, UIText2 } from '@cian/ui-kit/typography';
import { IconFunctionalInformation12 } from '@cian/ui-kit-design-tokens/icons';
import { plural } from '@cian/utils';
import React, { memo } from 'react';

import styles from './CoworkingWorkplacesCount.css';
import { ECoworkingOfferType } from '../../../types/offer';

interface ICoworkingWorkplacesCountProps {
  coworkingOfferType: ECoworkingOfferType;
  workplaceCount: number | null;
}

const FIXED_PLURAL: [string, string, string] = ['отдельное место', 'отдельных места', 'отдельных мест'];
const FLEXIBLE_PLURAL: [string, string, string] = [
  'незакреплённое место',
  'незакреплённых места',
  'незакреплённых мест',
];

function formatTitle(count: number | null, plurals: [string, string, string], fallback: string): string {
  if (count) {
    return `${count} ${plural(count, plurals)}`;
  }

  return fallback;
}

export const CoworkingWorkplacesCountComponent: React.FC<ICoworkingWorkplacesCountProps> = ({
  coworkingOfferType,
  workplaceCount,
}) => {
  let title: string;
  let tooltip: string;

  switch (coworkingOfferType) {
    case ECoworkingOfferType.FixedWorkplace:
      title = formatTitle(workplaceCount, FIXED_PLURAL, 'Отдельное место');
      tooltip = 'Этим столом будете пользоваться только вы';
      break;
    case ECoworkingOfferType.FlexibleWorkplace:
      title = formatTitle(workplaceCount, FLEXIBLE_PLURAL, 'Незакреплённое место');
      tooltip = 'Любое доступное рабочее место в общей зоне';
      break;
    default:
      return null;
  }

  return (
    <div className={styles['root']} data-name="CoworkingWorkplacesCount">
      <InlineText2>{title}</InlineText2>
      <TooltipDesktop theme="white" placement="top" title={<UIText2>{tooltip}</UIText2>}>
        <span className={styles['icon']}>
          <IconFunctionalInformation12 color="icon-main-default" />
        </span>
      </TooltipDesktop>
    </div>
  );
};

CoworkingWorkplacesCountComponent.displayName = 'CoworkingWorkplacesCount';

export const CoworkingWorkplacesCount = memo(CoworkingWorkplacesCountComponent);
